'use client';

import {
  type AuthSessionTransitionToken,
  publishAuthSessionObserverSnapshot,
} from '@/lib/auth/auth-session-observer';
import { useEffect } from 'react';

type UseAuthSessionObserverPublisherOptions = {
  status: 'loading' | 'authenticated' | 'unauthenticated';
  currentUserId: string | null;
  source: string;
  enabled?: boolean;
  transitionToken?: AuthSessionTransitionToken;
};

export function useAuthSessionObserverPublisher({
  status,
  currentUserId,
  source,
  enabled = true,
  transitionToken,
}: UseAuthSessionObserverPublisherOptions) {
  const transitionId = transitionToken?.id;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    publishAuthSessionObserverSnapshot(
      {
        status,
        currentUserId,
        source,
      },
      {
        transitionToken:
          transitionId === undefined ? undefined : { id: transitionId },
      }
    );
  }, [currentUserId, enabled, source, status, transitionId]);
}
